export default "__VITE_PUBLIC_ASSET__a4d19682__"